import React from 'react';
import { IconProps } from '.';

const SvgBoxKorea = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill='#fff'
        d='M2 5.333A3.333 3.333 0 0 1 5.333 2h13.334A3.333 3.333 0 0 1 22 5.333v13.334A3.333 3.333 0 0 1 18.667 22H5.333A3.333 3.333 0 0 1 2 18.667V5.333Z'
      />
      <path
        fill='#E0E0E4'
        fillRule='evenodd'
        d='M18.667 3.25H5.333c-1.15 0-2.083.933-2.083 2.083v13.334c0 1.15.933 2.083 2.083 2.083h13.334c1.15 0 2.083-.933 2.083-2.083V5.333c0-1.15-.933-2.083-2.083-2.083ZM5.333 2A3.333 3.333 0 0 0 2 5.333v13.334A3.333 3.333 0 0 0 5.333 22h13.334A3.333 3.333 0 0 0 22 18.667V5.333A3.333 3.333 0 0 0 18.667 2H5.333Z'
        clipRule='evenodd'
      />
      <path
        fill='#010101'
        d='m17.56 6.103-.503.335.926 1.39.504-.336-.926-1.39ZM16.299 6.942l.503-.335 2.023 3.035-.504.335-2.023-3.035ZM16.042 7.115l-.504.336.927 1.39.503-.337-.926-1.39ZM17.14 8.754l-.504.336.927 1.39.503-.336-.926-1.39ZM18.15 8.08l.504-.335.926 1.39-.504.335-.926-1.39ZM5.93 13.852l.504-.335 2.023 3.035-.503.335-2.023-3.035ZM5.176 14.358l.504-.335.926 1.39-.503.335-.927-1.39ZM6.776 15.669l-.504.336.927 1.39.504-.337-.927-1.39ZM4.415 14.868l.503-.336 2.023 3.035-.504.336-2.022-3.035ZM4.415 9.136l2.023-3.035.504.336L4.92 9.472l-.504-.336ZM7.197 6.603 5.174 9.638l.504.335L7.7 6.938l-.504-.335ZM7.956 7.11l-2.023 3.036.504.335L8.46 7.446l-.504-.335ZM16.634 14.906l.926-1.39.504.336-.926 1.39-.504-.336ZM15.54 16.553l.926-1.39.504.336-.926 1.39-.504-.336ZM17.225 15.665l-.927 1.39.504.335.927-1.39-.504-.335ZM17.394 15.414l.926-1.39.504.336-.926 1.39-.504-.336ZM17.983 16.173l-.926 1.39.504.335.926-1.39-.504-.335ZM18.15 15.92l.926-1.39.504.335-.926 1.39-.504-.336Z'
      />
      <path fill='#B51E3A' d='M8.968 9.979c-.015.02-.025.039-.04.058a.41.41 0 0 1 .04-.058Z' />
      <path
        fill='#B51E3A'
        d='M14.18 8.729a3.929 3.929 0 0 0-5.452 1.09A1.969 1.969 0 0 0 12.004 12a1.968 1.968 0 1 1 3.277 2.182 3.94 3.94 0 0 0-1.101-5.452Z'
      />
      <path
        fill='#273775'
        d='M8.729 9.82A1.969 1.969 0 0 0 12.005 12a1.968 1.968 0 1 1 3.276 2.18 3.93 3.93 0 0 1-5.451 1.091c-1.807-1.206-2.308-3.645-1.101-5.452Z'
      />
    </svg>
  );
};

export default SvgBoxKorea;
